import { render, staticRenderFns } from "./DatosLegales.vue?vue&type=template&id=e86e08d4"
import script from "./DatosLegales.vue?vue&type=script&lang=js"
export * from "./DatosLegales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports